export const AcceptDialog = {
    Titles: {
        Accept: 'Accept request',
        Decline: 'Decline request',
        Confirm: 'Confirm removal',
        BidAccept: 'Confirm Bid',
        SmsTitle: 'Curb-it Would Like to Send You Notifications via SMS'
    },
    Content: {
        Accept: 'You are accepting a request. Is this correct?',
        Decline: 'You are declining a request. Is this correct?',
        Delete: 'Delete picture?',
        BidAccept: `Are you sure you want to accept this bid ?`,
        SmsContent: 'This can be configures in Settings'
    },
    Buttons: {
        YES: 'Yes',
        NO: 'No',
        OK: 'Ok',
        DONT_ALLOW: `Don't Allow`
    }
}

export const InfoDialog = {
    Titles: {
        bidAccepted: 'Bid Accepted',
        setAvailability: 'Set Availability'
    },
    Content: {
        bidAccepted:
            'Your payment card has been authorized for ${0}. You will not be charged until your job is complete.',
        setAvailability:
            'Highlight more timeslots to increase the number of bids reveived.'
    },
    Buttons: {
        ok: 'Ok'
    }
}

export const AddPictures = {
    // Uploader
    Title: 'Add Pictures'
}

export const Comment = {
    // generic textarea container
    Labels: {
        CharsLeft: {
            Text: 'characters left'
        }
    }
}

export const DialogBox = {
    Titles: {
        ProviderPickupCancelled: 'Provider cancelled this job.',
        PickupCancelled: 'Job Cancelled',
        CancelPickup: 'Cancel Job?',
        CancelOrReschedule: 'Cancel or Reschedule?'
    },
    Content: {
        AreYouSureAssigned:
            'If you cancel this job, you will be charged a {0}% cancellation fee. Cancel job?',
        AreYouSure: 'Are you sure you want to cancel this job?',
        JobRepost:
            'Provider cancelled this job, but we are searching for another provider to honor this job.',
        CancelFee: `If you cancel this job, you will be charged a {0}% cancellation fee.
                To reschedule this job, click 'Reschedule Job' from below and specify for what date and time you like to reschedule the job for. A Curb-it customer success team member will help you.`
    },
    Buttons: {
        Ok: {
            label: 'Ok'
        },
        Yes: {
            label: 'Yes'
        },
        No: {
            label: 'No'
        },
        Cancel: {
            label: 'Cancel'
        },
        CancelJob: {
            label: 'Cancel Job'
        },
        Reschedule: {
            label: 'Reschedule Job'
        },
        Close: {
            label: 'Close'
        }
    }
}
export const JobCategory = {
    Title: 'Select Job Category'
}
export const JobDetails = {
    Paragraphs: {
        Completed: 'Completed:',
        Price: 'Price:'
    }
}

export const JobItemDetails = {
    Title: 'Job Details',
    Text: {
        ItemsAre: 'Items are',
        Outside: 'Outside',
        Inside: 'Inside',
        JobRequiresElevator: 'Requires use of elevator',
        JobRequiresStairs: 'Requires use of stairs'
    }
}
export const LocationSearch = {
    Inputs: {
        JobLocation: {
            label: 'JOB LOCATION'
        }
    },
    Checkboxes: {
        Apartment: {
            label: 'Apartment'
        }
    }
}

export const NumberOfItems = {
    Title: 'Specify the number of items'
}
export const PasswordChecker = {
    Options: {
        Length: {
            label: 'Must be at least 8 characters long.'
        },
        UpperCase: {
            label: 'Must contain some upper case letters.'
        },
        LowerCase: {
            label: 'Must contain some lower case letters.'
        },
        SomeNumbers: {
            label: 'Must contain some numbers.'
        },
        SomeSpecialChars: {
            label: 'Must contain some special characters.'
        },
        MustMatch: {
            label: 'Passwords must match.'
        }
    }
}
export const PickupLocationInfo = {
    Title: 'Job Location',
    Buttons: {
        ChangeLocation: {
            label: 'Change Job Location'
        }
    }
}
export const PickupTime = {
    Title: 'Set Job Time',
    Tabs: {
        Future: {
            label: 'Future'
        },
        Today: {
            label: 'Today'
        }
    },
    DatePickers: {
        PickupTime: {
            noLaterThan: 'No later than ',
            placeholder: 'Click to select a date'
        }
    }
}
export const SideMenuHeader = {
    Text: {
        unknownFirstName: 'Unknown',
        unknownLastName: 'user'
    }
}
export const Timer = {
    InfoText: {
        haulerDesc: `Did you know that our providers are background checked and insured.`,
        biddingExpiresSoon: `Please select a winner before the contest expires, or else you will need to publish your job again.`
    },
    Items: {
        Glass: {
            Title: 'Time Remaining:',
            timerExpiringText: 'Choose provider within:'
        },
        Timer: {
            primaryText: 'Waiting for Bids',
            secondaryText: `Please allow Providers time to review your job. We will notify you as soon as bids start rolling in.`,
            primaryTextLittleTimeLeft: 'It is getting late ...',
            secondaryTextLittleTimeLeft:
                'If you do not receive bids soon, more Providers may be available between 9 am - 7 pm.',
            remainingText: 'TIME REMAINING'
        }
    }
}
export const ChatProviderMessageItem = {
    Buttons: {
        Reply: {
            label: 'Reply'
        },
        Cancel: {
            label: 'Cancel'
        }
    }
}



// WEBPACK FOOTER //
// ./src/localization/Components.ts